/** Minha conta (fase 2, W4): abas, perfil, meus acessos, aparência pessoal e segurança. Mesclado em `conta` do núcleo. */
export const contaPt = {
  titulo: 'Minha conta',
  kicker: 'Conta',
  perfil: 'Perfil',
  nome: 'Nome',
  email: 'E-mail',
  aparencia: 'Aparência e idioma',
  rotuloAbas: 'Seções da conta',
  abas: { perfil: 'Perfil', aparencia: 'Aparência', notificacoes: 'Notificações', seguranca: 'Segurança', 'meus-dados': 'Meus dados' },
  salvarNome: 'Salvar nome',
  nomeSalvo: 'Nome atualizado',
  nomeVazio: 'Informe o seu nome',
  iniciais: 'Iniciais de {{nome}}',
  avatar: {
    escolher: 'Escolher foto',
    trocar: 'Trocar foto',
    remover: 'Remover foto',
    ajustar: 'Ajustar a foto',
    salvar: 'Salvar foto',
    descartar: 'Descartar',
    salva: 'Foto atualizada',
    removida: 'Foto removida; voltam as iniciais',
    processando: 'Processando a foto...',
    resultado: 'Assim a foto aparece no sistema. Salve para trocar.',
    resultadoAlt: 'Prévia da nova foto',
    removerTitulo: 'Remover a foto?',
    removerTexto: 'Voltam as iniciais do seu nome. Você pode escolher outra foto quando quiser.',
    tipoInvalido: 'Escolha uma imagem PNG, JPG ou WebP. SVG e outros formatos não são aceitos.',
    grandeDemais: 'Arquivo acima de 20 MB. Escolha uma imagem menor.',
    naoAbriu: 'Não foi possível abrir esta imagem. Escolha outro arquivo.',
    recorte: {
      area: 'Área de recorte da foto',
      ajuda: 'Arraste a foto ou use as setas (com Shift anda mais); a roda do mouse e as teclas + e - mudam o zoom. O círculo é só uma guia para centralizar o rosto.',
      zoom: 'Zoom',
      saida: 'Sai com {{largura}} × {{altura}} px',
      usar: 'Usar este recorte',
      cancelar: 'Cancelar',
      falhou: 'Não foi possível gerar a imagem neste navegador. Tente outro arquivo ou outro navegador.',
    },
  },
  entrada: {
    titulo: 'Como você entra',
    entraCom: 'Entra com:',
    formas: { ambos: 'e-mail ou nome de usuário, e senha', email: 'e-mail e senha', usuario: 'nome de usuário e senha' },
    senhaTexto: 'A senha é sua: você mesmo troca.',
    senhaLink: 'Trocar a senha em Segurança',
    trocaTexto: 'O e-mail e o nome de usuário são trocados pelo administrador do workspace: você faz o pedido e ele aprova ou recusa.',
    trocaTextoDireta: 'O seu e-mail você mesmo troca, com a senha atual. O nome de usuário é trocado pelo administrador do workspace: você faz o pedido e ele aprova ou recusa.',
    trocaTextoDiretaTudo: 'O seu e-mail e o seu nome de usuário você mesmo troca, com a senha atual.',
    semDecisor: 'A sua conta também está em outro workspace, e ninguém aqui pode aprovar a troca do e-mail ou do nome de usuário: peça a troca ao administrador da plataforma.',
    acessoLink: 'Trocar em Segurança',
    emailLink: 'Trocar o e-mail em Segurança',
    pedirEmail: 'Pedir novo e-mail',
    pedirAdicionarEmail: 'Pedir para adicionar e-mail',
    pedirUsuario: 'Pedir novo nome de usuário',
    enviarPedido: 'Enviar pedido',
    pedidoEnviado: 'Pedido enviado ao administrador',
    pedidoCancelado: 'Pedido cancelado',
    cancelarPedido: 'Cancelar pedido',
    aguardando: 'Aguardando o administrador',
    status: { aprovado: 'Aprovado', recusado: 'Recusado' },
    pedido: { email: 'Novo e-mail: {{valor}}', usuario: 'Novo nome de usuário: {{valor}}' },
    motivo: 'Motivo: {{motivo}}',
    modal: {
      email: {
        titulo: 'Pedir novo e-mail',
        texto: 'O administrador recebe o pedido. Se aprovar, enviamos um link de confirmação para o e-mail novo; a troca só vale depois que você abrir o link.',
        campo: 'E-mail novo',
        ajuda: 'O e-mail de hoje recebe um aviso quando a troca for pedida e quando for confirmada.',
      },
      usuario: {
        titulo: 'Pedir novo nome de usuário',
        texto: 'O administrador recebe o pedido. Se aprovar, o nome muda na hora e você entra com ele.',
        campo: 'Nome de usuário novo',
        ajuda: 'De 2 a 40 letras sem acento, números, ponto, hífen ou sublinhado, sem "@".',
      },
    },
  },
  tour: { titulo: 'Tour do sistema', texto: 'Mostra de novo o passeio pelas áreas principais.', botao: 'Rever o tour' },
  acessos: {
    titulo: 'Meus acessos',
    texto: 'O que os seus papéis permitem neste workspace, por módulo.',
    textoSubsistemas: 'O que os seus papéis abrem neste workspace, por sub-sistema que você usa e página.',
    vazio: 'Você ainda não tem permissões neste workspace. Fale com o administrador.',
    modulos_one: '{{count}} módulo',
    modulos_other: '{{count}} módulos',
  },
  notificacoes: {
    titulo: 'Notificações',
    texto: 'As preferências de notificação ficam numa tela própria, que chega com a central de avisos.',
  },
  fonte: {
    titulo: 'Fonte do texto',
    texto: 'Escolha a fonte do texto só para você. Números e valores continuam na fonte de largura fixa, para as colunas não desalinharem.',
    doWorkspace: 'A do workspace',
    doWorkspaceNome: 'A do workspace ({{nome}})',
    doEstiloNome: 'A do estilo ({{nome}})',
    sistema: 'Fonte do sistema',
    enviada: 'Enviada pelo administrador',
    bloqueada: 'O administrador definiu a mesma fonte para todos neste workspace.',
    amostra: 'Ação rápida: código Il1O0, 25 itens, 98,5%, ñ ¿ ¡',
    facilLer: 'Mais fácil de ler',
    escala: 'Tamanho do texto',
    escalaAjuda: 'Aumenta todo o texto da tela, para ler com mais conforto.',
    salva: 'Preferência salva',
  },
  estilo: {
    titulo: 'Estilo',
    texto: 'Escolha o visual do sistema só para você. Maré, Gelo e Malgo trazem as cores da marca; os outros estilos mudam cantos, fonte, efeitos, profundidade e sombras, inspirados no design system público de grandes marcas. Os nomes entre parênteses são só referência; nada é oficial dessas marcas.',
    seguirPadrao: 'Padrão do workspace',
    fixado: 'O administrador definiu o estilo {{nome}} para a sua conta.',
    bloqueado: 'O administrador definiu o mesmo estilo para todos neste workspace: {{nome}}.',
    padrao: 'Padrão',
    nomes: {
      mare_malgo: 'Maré',
      gelo: 'Gelo',
      malgo: 'Malgo (atual)',
      proprio: 'Modelo próprio',
      cupertino: 'Cupertino (inspirado na Apple)',
      mare: 'Navy (inspirado no RD Station)',
      redmond: 'Redmond (inspirado na Microsoft)',
      mountain_view: 'Mountain View (inspirado no Google)',
      armonk: 'Armonk (inspirado na IBM)',
      embarcadero: 'Embarcadero (inspirado na Salesforce)',
      sydney: 'Sydney (inspirado na Atlassian)',
      grafite: 'Grafite (inspirado no GitHub)',
      ottawa: 'Ottawa (inspirado na Shopify)',
    },
    salvo: 'Estilo salvo',
  },
  simples: {
    titulo: 'Modo simples',
    ajuda: 'Esconde as abas e os campos avançados, para ficar só o que se usa no dia a dia. Nada é apagado e você pode desligar quando quiser.',
    desligado: 'Desligado',
    ligado: 'Ligado',
  },
  seguranca: {
    senha: {
      titulo: 'Senha',
      atual: 'Senha atual',
      nova: 'Senha nova',
      confirmar: 'Confirmar senha nova',
      ajuda: 'Use ao menos 10 caracteres. Ao trocar, os outros aparelhos saem da conta.',
      trocar: 'Trocar senha',
      diferentes: 'As senhas não conferem',
      // Review r28 spec (O6): o zero tem forma própria (com count 0, o i18next procura o `_zero` antes).
      trocada_zero: 'Senha trocada. Nenhum outro aparelho estava com a conta aberta.',
      trocada_one: 'Senha trocada. {{count}} outro aparelho saiu da conta.',
      trocada_other: 'Senha trocada. {{count}} outros aparelhos saíram da conta.',
    },
    mfa: {
      titulo: 'Verificação em duas etapas',
      texto: 'Além da senha, o login pede um código de 6 dígitos do aplicativo autenticador (Google Authenticator, Microsoft Authenticator, 1Password ou outro).',
      ativa: 'Ativa',
      inativa: 'Desativada',
      obrigatoria: 'Seu papel exige a verificação em duas etapas. Configure até {{data}}.',
      obrigatoriaAgora: 'Seu papel exige a verificação em duas etapas. Configure agora para continuar.',
      lembreteLogin: 'Seu papel exige a verificação em duas etapas. Configure até {{data}} em Minha conta > Segurança.',
      obrigatoriaAtiva: 'Obrigatória para o seu papel',
      ativar: 'Ativar',
      passo1: 'Leia o código QR com o aplicativo autenticador.',
      passo1Alt: 'Sem câmera? Digite esta chave no aplicativo:',
      passo2: 'Digite o código de 6 dígitos que o aplicativo mostra.',
      codigo: 'Código do aplicativo',
      codigoOuBackup: 'Código do aplicativo ou de backup',
      confirmarAtivar: 'Confirmar e ativar',
      encerrarOutras: 'Encerrar as outras sessões (os outros aparelhos entram de novo com o código)',
      qrRotulo: 'Código QR para o aplicativo autenticador',
      chave: 'Chave',
      backupsTitulo: 'Códigos de backup',
      backupsTexto: 'Guarde estes códigos num lugar seguro. Cada um vale uma vez, para entrar sem o celular. Eles não aparecem de novo.',
      copiarCodigos: 'Copiar códigos',
      guardei: 'Já guardei os códigos',
      backupsRestantes_one: '{{count}} código de backup disponível',
      backupsRestantes_other: '{{count}} códigos de backup disponíveis',
      novosBackups: 'Gerar novos códigos de backup',
      novosBackupsTexto: 'Os códigos anteriores deixam de valer. Digite um código do aplicativo para confirmar.',
      trocarAparelho: 'Trocar de aparelho',
      trocarAparelhoTexto: 'Digite um código do aplicativo atual. Depois, leia o novo código QR no aparelho novo.',
      desativar: 'Desativar',
      desativarTexto: 'Digite um código do aplicativo ou um código de backup para desativar.',
      ativada: 'Verificação em duas etapas ativada',
      desativada: 'Verificação em duas etapas desativada',
      continuar: 'Continuar',
    },
    sessoes: {
      titulo: 'Sessões ativas',
      texto: 'Aparelhos com a sua conta aberta agora.',
      esteAparelho: 'Este aparelho',
      sair: 'Sair deste aparelho',
      sairTodos: 'Sair de todos os outros aparelhos',
      sairTodosTexto: 'Os outros aparelhos saem da conta na hora. Este continua aberto.',
      ultimoUso: 'Último uso: {{quando}}',
      desconhecido: 'Aparelho desconhecido',
      movel: 'celular',
      ip: 'IP {{ip}}',
      soEste: 'Só este aparelho está com a conta aberta.',
      encerrada: 'Aparelho desconectado',
      encerradas_zero: 'Nenhum outro aparelho estava com a conta aberta',
      encerradas_one: '{{count}} aparelho desconectado',
      encerradas_other: '{{count}} aparelhos desconectados',
    },
    acesso: {
      titulo: 'Acesso à conta',
      texto: 'Você entra com o e-mail ou com o nome de usuário, sempre com a mesma senha. A conta é a mesma em todas as empresas em que você trabalha.',
      usuario: 'Nome de usuário',
      email: 'E-mail',
      semEmail: 'Sem e-mail',
      semEmailTexto: 'Sem e-mail, a recuperação da senha e da verificação em duas etapas é com o administrador, e os avisos de segurança chegam nas Notificações.',
      trocarEmail: 'Trocar e-mail',
      adicionarEmail: 'Adicionar e-mail',
      emailNovo: 'E-mail novo',
      emailNovoAjuda: 'Enviamos um link para ele. A troca só vale depois da confirmação; o e-mail de hoje recebe um aviso.',
      emailInvalido: 'Informe um e-mail válido',
      enviar: 'Enviar link de confirmação',
      enviado: 'Se o endereço puder ser usado, enviamos o link para ele. A troca só vale depois da confirmação.',
      trocarUsuario: 'Trocar nome de usuário',
      usuarioNovo: 'Nome de usuário novo',
      usuarioNovoAjuda: 'De 2 a 40 letras sem acento, números, ponto, hífen ou sublinhado, sem "@". Vale na hora; o nome de hoje deixa de entrar.',
      usuarioInvalido: 'O nome de usuário não pode ter "@"',
      salvarUsuario: 'Salvar nome de usuário',
      usuarioTrocado: 'Nome de usuário trocado',
    },
    trocaObrigatoria: {
      titulo: 'Troque a senha provisória',
      texto: 'A senha que você recebeu do administrador vale só para o primeiro acesso. Escolha a sua senha para continuar. Seu nome de usuário: {{usuario}}.',
    },
    forcada: {
      titulo: 'Configure a verificação em duas etapas',
      texto: 'Seu papel exige um segundo passo no login. Configure agora para continuar usando o sistema.',
    },
  },
};
